jQuery3_4_1(document).ready(function($){
    class HotspotManager {
        init(){
            // console.log("Remember to edit or remove the JS of your new component: hotspot"); 
            // this.registerEvents();
        }
        
        registerEvents(){
            const self = this;
            $(document).on({
                click:function(event){
                    console.log("Was clicked:", event);
                },
            },".dd-hotspot");
        }
    }

    const hotspotManager = new HotspotManager();
    hotspotManager.init();
});